var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('VisualAtmosphere'),_c('router-view',{key:_vm.session.user ? _vm.session.user.id : 'signed-out'})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }